import { useSearchParams } from "react-router-dom";
import { Tabs } from "..";

export const TabsWithClientActions = ({ ...props }: any) => {
  const [_, setSearchParams] = useSearchParams();
  const handleClearURL = () => setSearchParams();
  return <Tabs {...props} onValueChange={handleClearURL} />;
};
